import http, { authHeader } from './index'

const url = '/enums/'

export const httpGetEnums = () => {
  console.log("httpGetEnums");
  return http({
    url: `${url}`,
    method: 'GET',
    headers: {
      ...authHeader(),
    },
  })
}
